import React, {Component} from 'react';
import Stage from '../stage/stage';
import Size from './size';
import LayerList from './layer-list';
import BackgroundNoise from './background-noise';
import './stage-editor.css';

/** @class StageEditor
 * A StageEditor component enables a user to modify
 * a stage corresponding to a specific location in
 * an expo.
 */
export default class StageEditor extends Component {
  render() {
    return (
      <div>
        <div className="stage-editor">
          <div className="sidebar">
            <Size dataURL={this.props.dataURL} />
            <BackgroundNoise dataURL={this.props.dataURL + '/noise'}/>
            <LayerList dataURL={this.props.dataURL + '/layers'}/>
          </div>
          <div className="zoom-panel">
            <Stage dataURL={this.props.dataURL} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/stage-editor/stage-editor.js